export default "https://cdn-static.gokick.com/assets/3cd141d05df56e6b81a0153ff619f4101846aa93/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";